import { render, staticRenderFns } from "./ProjectEstimatesRoleTab.vue?vue&type=template&id=e3080fd6"
import script from "./ProjectEstimatesRoleTab.vue?vue&type=script&lang=js"
export * from "./ProjectEstimatesRoleTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports